module.exports = __webpack_public_path__ + "img/box.1bace502.png";